import { LOGGER } from '@cicero/data/utils'
import { IAction, IActionHandler, Store } from 'models/services'
import { WrongParamsError } from 'models/helpers'

export class QUERY_MODELS_OVER_HTTP implements IActionHandler<IQueryParamsPayload, any> {
  async exec(action: IAction<IQueryParamsPayload>, store: Store) {
    if (!action.payload) { throw new Error('Action has no payload') }
    const { model, params } = action.payload
    const M = store.getModelByName(model || '')
    if (M.schema.LIFECYCLE.fetchQuery === undefined) {
      LOGGER.warn(`There is no fetchQuery function configured for model: ${M.schema.NAME}`)
      return
    }
    const results = await M.schema.LIFECYCLE.fetchQuery(store, params)

    if (results === null) { return null }
    if (results === undefined) {
      throw new WrongParamsError(`A fetchQuery for model "${model}" returned undefined. This is probably a bug. Return null for now match " `, params)
    }

    return Promise.all(results.map(async v => M.PERSIST(v)))
  }
}

interface IQueryParamsPayload {
  model: string
  params: any
}
